import React from 'react';
import styled from 'styled-components';
import { styled as muiStyled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

// backgroundheadercolor has to be lower case otherwise we get a console warning
interface AccordionSummaryPropsExtended extends AccordionSummaryProps {
  backgroundheadercolor: string;
}

export const ParentContainer = styled.div`
    padding-right: 0.6rem;
`;

export const StyledTitle = styled.div`
    font-weight: bold;
    font-size: medium;
    padding-bottom: 0.5rem;
`;

export const StyledAccordion = muiStyled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  '&:before': {
    display: 'none',
  },
}));

export const StyledAccordionSummary = muiStyled((props: AccordionSummaryPropsExtended) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme, backgroundheadercolor }) => ({
  backgroundColor: backgroundheadercolor,
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

export const StyledAccordionDetails = muiStyled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));